import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Leaderboard } from '@/components/customComponents'

import { useBoughtTogetherItems, useModifiersItems } from '@/hooks'
import {
  selectPageRefreshTrigger,
  useAppSelector,
  useReduxSalesLensFilter,
} from '@/store'
import { dateToString } from '@/utils'

interface BoughtTogetherTabProps {
  itemName: string
}

export const BoughtTogetherTab = ({ itemName }: BoughtTogetherTabProps) => {
  const { t } = useTranslation()
  const { selectedBranch, date, sizeFilter, temperatureFilter } =
    useReduxSalesLensFilter()
  const refreshTrigger = useAppSelector(
    selectPageRefreshTrigger('sales-lens-item')
  )

  const {
    boughtTogetherItemsChartData,
    boughtTogetherItemsColumns,
    loading: boughtTogetherItemsLoading,
    refetch: boughtTogetherItemsRefetch,
  } = useBoughtTogetherItems(
    dateToString(date, 'from'),
    dateToString(date, 'to'),
    selectedBranch,
    itemName,
    sizeFilter,
    temperatureFilter
  )

  const {
    modifiersItemsChartData,
    modifiersItemsColumns,
    loading: modifiersItemsLoading,
    refetch: modifiersItemsRefetch,
  } = useModifiersItems(
    dateToString(date, 'from'),
    dateToString(date, 'to'),
    selectedBranch,
    itemName,
    sizeFilter,
    temperatureFilter
  )

  // Refetch data when refresh trigger is triggered
  useEffect(() => {
    if (refreshTrigger) {
      console.log('Refreshing total sales revenue chart data...')
      boughtTogetherItemsRefetch()
      modifiersItemsRefetch()
    }
  }, [refreshTrigger, boughtTogetherItemsRefetch, modifiersItemsRefetch])

  return (
    <div className="space-y-6">
      <div>
        <Leaderboard
          title={t('clarityLens.salesLens.tabs.boughtTogether')}
          data={boughtTogetherItemsChartData}
          loading={boughtTogetherItemsLoading}
          columns={boughtTogetherItemsColumns}
          enablePagination
          itemsPerPage={5}
          sortBy="count"
        />
      </div>
      <div>
        <Leaderboard
          title={t('clarityLens.salesLens.charts.modifiers')}
          data={modifiersItemsChartData}
          loading={modifiersItemsLoading}
          columns={modifiersItemsColumns}
          enablePagination
          itemsPerPage={5}
          sortBy="count"
        />
      </div>
    </div>
  )
}
